import { render } from "./App.vue?vue&type=template&id=39dea723"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "wow.js/css/libs/animate.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=39dea723&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__